<template>
  <div class="footer">
    <div class="show_list">
      <div class="left">
        <div class="h1 bot-dis" @click="goSearch()" style="cursor: pointer;width: 400px;">
          <img src="@/assets/bot-icon1.png" class="bot-icon" />Institute of High Energy Physics
        </div>
        <div
          class="h1 bot-dis"
          @click="goSearchTwo()"
          style="margin-top: 6px;cursor: pointer;width: 400px;"
        >
          <img src="@/assets/bot-icon2.png" class="bot-icon" />
          National HEP Data Center
        </div>
        <div class="listWrapper">
          <div class="li">
            <div class="img3 img"></div>
            <p>Postal Code:{{postalCode}}</p>
          </div>
          <div class="li">
            <div class="img4 img"></div>
            <p>Telephone: {{telephone}}</p>
          </div>
          <div class="li">
            <div class="img5 img"></div>
            <p>Email: {{email}}</p>
          </div>
          <div class="li" style="width: 500px;">
            <div class="img1 img"></div>
            <p>Address: {{address}}</p>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="h1" style="opacity: 0;margin-top: 5px">Other Useful Links</div>
        <div class="h1">Other Useful Links</div>
        <div class="ul">
          <div class="li">
            <span></span>
            <p class="cursor" @click="link('link1')">{{linkName?linkName:'NO NAME'}}</p>
          </div>
          <div class="li">
            <span></span>
            <p class="cursor" @click="link('link2')">{{linkName2?linkName2:'NO NAME'}}</p>
          </div>
          <div class="li">
            <span></span>
            <p>
              Courtesy of the original authors and platforms who produced and distributed these information. See more in
              <span
                class="lanse cursor"
                @click="goAbout"
              >Disclaimer</span>.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="number">
      <div>{{copyright}}</div>
      <div>
        <!-- 修复笔误：_black → _blank，否则新窗口打开失败 -->
        <a class="tx" href="https://beian.miit.gov.cn/" target="_blank">备案序号：京 ICP 备 05002790 号</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "showEnd",
  data() {
    return {
      indexData2: {},
      address: "",
      maintenance: "",
      postalCode: "",
      telephone: "",
      email: "",
      linkName: "",
      copyright: "",
      linkName2: ""
    };
  },
  mounted() {
    // 优先初始化百度统计，再请求业务数据
    this.initBaiduStat();
    this.getData();
  },
  methods: {
    // 新增：百度统计初始化（动态创建脚本，无模板污染）
    initBaiduStat() {
      // 全局挂载_hmt，防止重复定义
      window._hmt = window._hmt || [];
      // 创建百度统计脚本标签
      const hmScript = document.createElement("script");
      hmScript.src = "https://hm.baidu.com/hm.js?b5941daa896a453111c8df05eacebeef";
      hmScript.async = true; // 异步加载，不阻塞页面渲染
      // 插入到页面第一个script标签前
      const firstScript = document.getElementsByTagName("script")[0];
      firstScript.parentNode.insertBefore(hmScript, firstScript);

      // 【重要】Vue路由单页应用必加：监听路由切换，统计所有页面PV
      this.$router.afterEach((to) => {
        window._hmt.push(['_trackPageview', to.fullPath]);
      });
    },
    // 原有链接跳转方法
    link(e) {
      if (e === "link1") {
        this.indexData2.linkUrl?.description && window.open(this.indexData2.linkUrl.description);
      } else {
        this.indexData2.linkUrl2?.description && window.open(this.indexData2.linkUrl2.description);
      }
    },
    // 原有路由跳转方法
    goAbout() {
      this.$router.push("/about");
    },
    // 原有外部链接跳转
    goSearch() {
      window.open("http://english.ihep.cas.cn/");
    },
    goSearchTwo() {
      window.open("https://www.nhepsdc.cn/");
    },
    // 原有数据请求方法
    getData() {
      this.$fetchGet("/cms-middle/cmsSite/config?type=basic")
        .then(result => {
          this.indexData2 = result.config || {};
          // 可选链操作，防止字段不存在时报错
          this.address = this.indexData2.address?.description || "";
          this.maintenance = this.indexData2.maintenance?.description || "";
          this.postalCode = this.indexData2.postalCode?.description || "";
          this.telephone = this.indexData2.telephone?.description || "";
          this.email = this.indexData2.email?.description || "";
          this.linkName = this.indexData2.linkName?.description || "";
          this.linkName2 = this.indexData2.linkName2?.description || "";
          this.copyright = this.indexData2.copyright?.description || "";
        })
        .catch(err => {
          console.error("页脚数据请求失败：", err); // 新增错误打印，方便调试
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.lanse {
  text-decoration: underline;
  font-weight: 700;
}
.footer {
  width: 100%;
  position: relative;
  /* bottom: 0; */
  z-index: 99;
}
.show_list {
  display: flex;
  justify-content: space-evenly;
  color: #ffffff;
  height: 149px;
  font-size: 11px;
  align-items: center;
  background: #396592;
  padding-top: 12px;
}
.img {
  width: 10px;
  height: 10px;
}
.img1 {
  width: 9px;
  height: 10px;
  background: url(@/assets/slices_slices/1.png) no-repeat center center;
  background-size: 100% 100%;
}
.img2 {
  width: 11px;
  height: 10px;
  background: url(@/assets/slices_slices/2.png) no-repeat center center;
  background-size: 100% 100%;
}
.img3 {
  background: url(@/assets/slices_slices/3.png) no-repeat center center;
  background-size: 100% 100%;
}
.img4 {
  background: url(@/assets/slices_slices/4.png) no-repeat center center;
  background-size: 100% 100%;
}
.img5 {
  background: url(@/assets/slices_slices/5.png) no-repeat center center;
  background-size: 100% 100%;
}
.h1 {
  font-size: 18px;
  font-family: Arial;
  font-weight: bold;
  color: #ffffff;
  text-align: left;
}
.left {
  /* width: 600px; */
  width: 30%;
}
.li p {
  margin: 0;
  margin-left: 5px;
}
.listWrapper {
  display: flex;
  flex-wrap: wrap;
  margin-top: 6px;
}
.listWrapper .li {
  width: 300px;
  display: flex;
  align-items: center;
  font-size: 10px;
  height: 24px;
}
.right {
  height: 100px;
  width: 700px;
}
.right .h1 {
  text-align: right;
}
.right .ul {
  margin-top: 6px;
  width: 100%;
}
.right-bot {
  display: flex;
  flex-direction: column;
  justify-items: flex-end;
}
.ul .li {
  display: flex;
  height: 24px;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
}
.ul .li span {
  width: 4px;
  height: 4px;
  /* background: #fff; */
}
.number {
  background: #325b87;
  color: #ffffff;
  text-align: center;
  font-size: 11px;
  font-family: Arial;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  line-height: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.tx {
  color: #ffffff;
}
.cursor {
  cursor: pointer;
}
.bot-icon {
  width: 30px;
  height: 30px;
}
.bot-dis {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 20px;
}
</style>
